import {
  CarrierBillingAccountSchema,
  CreateCarrierBillingAccountSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/carrier-billing-accounts";
import * as z from "zod";

/** Name predates receiver billing; renaming it would break in-flight bundles. */
export const createThirdPartyBillingAccount = {
  name: "createThirdPartyBillingAccount" as const,
  input: CreateCarrierBillingAccountSchema.omit({ team: true }),
  output: z.object({ account: CarrierBillingAccountSchema }),
};
